import { SVGProps } from 'react';

export const ArrowDown = ({
  width = 13,
  height = 8,
  className,
  strokeWidth = '1.5',
  stroke,
}: SVGProps<SVGElement>): JSX.Element => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 13 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M1 1.3418L6.34168 6.68348L11.6834 1.3418"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
